(() => {
  const KEY = 'viextaWishlist';

  const cleanPrice = (value) => {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = String(value ?? '');
    const decoded = decoder.value;
    const holder = document.createElement('div');
    holder.innerHTML = decoded;
    return (holder.textContent || decoded).replace(/\s+/g, ' ').trim();
  };

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(value)) return [];
      return value.map((item) => ({ ...item, price: cleanPrice(item.price) }));
    } catch (_) {
      return [];
    }
  };

  const write = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    refresh();
  };

  const esc = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const refreshCount = (items) => {
    document.querySelectorAll('[data-viexta-wishlist-count]').forEach((badge) => {
      badge.textContent = items.length;
      badge.hidden = items.length === 0;
    });
  };

  const refreshButtons = (items) => {
    const handles = new Set(items.map((item) => item.handle));
    document.querySelectorAll('[data-viexta-wishlist-add]').forEach((button) => {
      const saved = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const label = button.querySelector('[data-viexta-wishlist-label]');
      if (label) label.textContent = saved ? 'Saved to wishlist' : 'Add to wishlist';

      const productTitle = button.dataset.productTitle || 'product';
      if (button.hasAttribute('data-viexta-wishlist-icon-only')) {
        button.setAttribute('aria-label', saved ? `Remove ${productTitle} from wishlist` : `Add ${productTitle} to wishlist`);
        button.setAttribute('title', saved ? 'Remove from wishlist' : 'Add to wishlist');
      }
    });
  };

  const refreshDrawer = (items) => {
    document.querySelectorAll('[data-viexta-wishlist-items]').forEach((container) => {
      container.innerHTML = items.map((item) => `
        <article class="viexta-wishlist-item">
          <a class="viexta-wishlist-item__image-link" href="${esc(item.url)}">
            ${item.image ? `<img class="viexta-wishlist-item__image" src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">` : ''}
          </a>
          <div class="viexta-wishlist-item__info">
            <p class="viexta-wishlist-item__title"><a class="viexta-wishlist-item__link" href="${esc(item.url)}">${esc(item.title)}</a></p>
            <p class="viexta-wishlist-item__price">${esc(cleanPrice(item.price))}</p>
          </div>
          <button type="button" class="button-unstyled viexta-wishlist-remove" data-viexta-wishlist-remove="${esc(item.handle)}" aria-label="Remove ${esc(item.title)} from wishlist" title="Remove from wishlist">
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" fill="currentColor" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </article>
      `).join('');
    });

    document.querySelectorAll('[data-viexta-wishlist-empty]').forEach((empty) => {
      empty.hidden = items.length !== 0;
    });
  };

  const refresh = () => {
    const items = read();
    refreshCount(items);
    refreshButtons(items);
    refreshDrawer(items);
  };

  let lastTrigger = null;

  const openDrawer = () => {
    refresh();
    document.querySelectorAll('[data-viexta-wishlist-drawer]').forEach((drawer) => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    });
    document.querySelectorAll('[data-viexta-wishlist-overlay]').forEach((overlay) => {
      overlay.hidden = false;
    });
    document.documentElement.style.overflow = 'hidden';
    const drawer = document.querySelector('[data-viexta-wishlist-drawer]');
    drawer?.focus();
  };

  const closeDrawer = () => {
    document.querySelectorAll('[data-viexta-wishlist-drawer]').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-viexta-wishlist-overlay]').forEach((overlay) => {
      overlay.hidden = true;
    });
    document.documentElement.style.overflow = '';
    lastTrigger?.focus?.();
    lastTrigger = null;
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-viexta-wishlist-open]');
    if (open) {
      event.preventDefault();
      lastTrigger = open;
      openDrawer();
      return;
    }

    const close = event.target.closest('[data-viexta-wishlist-close], [data-viexta-wishlist-overlay]');
    if (close) {
      closeDrawer();
      return;
    }

    const add = event.target.closest('[data-viexta-wishlist-add]');
    if (add) {
      lastTrigger = add;
      const item = {
        handle: add.dataset.productHandle,
        title: add.dataset.productTitle,
        url: add.dataset.productUrl,
        image: add.dataset.productImage,
        price: cleanPrice(add.dataset.productPrice)
      };
      const items = read();
      const index = items.findIndex((existing) => existing.handle === item.handle);
      const isAdding = index < 0;
      if (index >= 0) items.splice(index, 1);
      else items.unshift(item);
      write(items);
      if (isAdding) openDrawer();
      return;
    }

    const remove = event.target.closest('[data-viexta-wishlist-remove]');
    if (remove) {
      write(read().filter((item) => item.handle !== remove.dataset.viextaWishlistRemove));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  window.addEventListener('storage', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();